import React, { useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { find, size, remove, set } from "lodash";
import(
  /* webpackChunkName: "order-builder-ite-custom-options" */ "./iteCustomOptions.scss"
);
import InsertLink from "@material-ui/icons/InsertLink";
import LinkOff from "@material-ui/icons/LinkOff";
import testModel from "../../../../assets/img/ModelTest.png";
import config from "../../../../config";
import { use } from "react";

const ITECustomOptions = ({
  customOptionsGroupLeft,
  customOptionsGroupRight,
  setITECustomOptionsForOrder,
  leftSelected,
  rightSelected,
  selectedShellStyleLeft,
  selectedShellStyleRight,
  iteModelLinked,
  manualVent,
  cartData,
  selectedPresetRight,
  selectedPresetLeft,
}) => {
  const [linked, setLinked] = useState(true);
  const [selectedCustomOptionsRight, setSelectedCustomOptionsRight] = useState(
    []
  );
  const [selectedCustomOptionsLeft, setSelectedCustomOptionsLeft] = useState(
    []
  );
  const [advancedMode, setAdvancedMode] = useState(false);
  const [hasAdvancedSettings, setHasAdvancedSettings] = useState(false);
  var manualVentOptionToRemove = "Acoustically Optimized Venting";
  if (config.siteName == "UNITRON") {
    manualVentOptionToRemove = "IntelliVent";
  }

  const [shellStyleLeft, setShellStyleLeft] = useState("");
  const [shellStyleRight, setShellStyleRight] = useState("");

  const [rightLocked, setRightLocked] = useState(false);
  const [leftLocked, setLeftLocked] = useState(false);

  useEffect(() => {
    let tempShellStyleRight = "";
    if (selectedShellStyleRight) {
      tempShellStyleRight = selectedShellStyleRight;
      if (selectedShellStyleRight.Code) {
        tempShellStyleRight = selectedShellStyleRight.Code;
      }
      setShellStyleRight(tempShellStyleRight);
    }

    let tempShellStyleLeft = "";
    if (selectedShellStyleLeft) {
      tempShellStyleLeft = selectedShellStyleLeft;
      if (selectedShellStyleLeft.Code) {
        tempShellStyleLeft = selectedShellStyleLeft.Code;
      }
      setShellStyleLeft(tempShellStyleLeft);
    }
  }, [selectedShellStyleRight, selectedShellStyleLeft]);

  useEffect(() => {
    // console.log("Should update", customOptionsGroupRight, customOptionsGroupLeft)
  }, [customOptionsGroupRight, customOptionsGroupLeft]);

  useEffect(() => {
    setRightLocked(
      selectedPresetRight && selectedPresetRight !== "manual" ? true : false
    );
  }, [selectedPresetRight]);

  useEffect(() => {
    setLeftLocked(
      selectedPresetLeft && selectedPresetLeft !== "manual" ? true : false
    );
  }, [selectedPresetLeft]);

  useEffect(() => {
    // Set default values for each option
    const hasAdvancedSettingsRight = find(customOptionsGroupRight, {
      IsAdvanced: true,
    });
    const hasAdvancedSettingsLeft = find(customOptionsGroupLeft, {
      IsAdvanced: true,
    });

    setHasAdvancedSettings(
      Boolean(hasAdvancedSettingsRight || hasAdvancedSettingsLeft)
    );

    if (customOptionsGroupRight && selectedCustomOptionsRight.length === 0) {
      let tempOptionsArrayRight = [];
      customOptionsGroupRight.forEach((option) => {
        if (manualVent) {
          var optionsAfterSplit = splitOptions(option.Options);
          remove(optionsAfterSplit, function (o) {
            // return o == manualVentOptionToRemove;
            return o
              ?.toLowerCase()
              .includes(manualVentOptionToRemove.toLowerCase());
          });
          tempOptionsArrayRight.push(optionsAfterSplit[0]);
        } else {
          tempOptionsArrayRight.push(option.DefaultValue);
        }
      });
      setSelectedCustomOptionsRight(tempOptionsArrayRight);
    }

    if (customOptionsGroupLeft && selectedCustomOptionsLeft.length === 0) {
      let tempOptionsArrayLeft = [];
      customOptionsGroupLeft.forEach((option) => {
        if (manualVent) {
          var optionsAfterSplit = splitOptions(option.Options);
          remove(optionsAfterSplit, function (o) {
            // return o == manualVentOptionToRemove;
            return o
              ?.toLowerCase()
              .includes(manualVentOptionToRemove.toLowerCase());
          });
          tempOptionsArrayLeft.push(optionsAfterSplit[0]);
        } else {
          tempOptionsArrayLeft.push(option.DefaultValue);
        }
      });
      setSelectedCustomOptionsLeft(tempOptionsArrayLeft);
    }
  }, [customOptionsGroupLeft, customOptionsGroupRight]); // manualVent intentionally not here

  useEffect(() => {
    // Set customOptions for order
    const tempITECustomOptionsForOrder = {
      right: selectedCustomOptionsRight,
      left: selectedCustomOptionsLeft,
    };
    setITECustomOptionsForOrder(tempITECustomOptionsForOrder);
  }, [selectedCustomOptionsRight, selectedCustomOptionsLeft]);

  // helper (existing)
  const buildDefaults = (group, side) => {
    return (group ?? []).map((option, idx) => {
      const presetVal = getPresetOptionValue(side, option);
      if (presetVal) return presetVal;

      let opts = splitOptions(option.Options);

      // shared removals
      if (manualVent) {
        // opts = opts.filter((o) => o !== manualVentOptionToRemove);
        opts = opts.filter(
          (o) =>
            !o?.toLowerCase().includes(manualVentOptionToRemove.toLowerCase())
        );
      }
      const shellStyle = side === "right" ? shellStyleRight : shellStyleLeft;

      if (
        shellStyle === "Canal_Mold" ||
        shellStyle === "Canal_Lock" ||
        shellStyle === "Carved_Half" ||
        shellStyle === "CanalMold" ||
        shellStyle === "CanalLock" ||
        shellStyle === "CarvedHalf"
      ) {
        opts = opts.filter((o) => o !== "Full Helix");
      }

      const selectedTube =
        side === "right"
          ? selectedCustomOptionsRight[1]
          : selectedCustomOptionsLeft[1];

      if (selectedTube === "# 13 Dry Wall Tube") {
        opts = opts.filter((o) => !["00", "0", "2", "3"].includes(o));
      }

      if (cartData?.some((i) => i.ModelTypeCode?.includes("UP"))) {
        opts = opts.filter((o) => o !== "SlimTube 4.0");
      }

      // prefer the server default if still valid, else first available
      return opts.includes(option.DefaultValue)
        ? option.DefaultValue
        : opts[0] ?? "";
    });
  };

  // options.Options is the pipe-separated list ("A|B|C")
  // options.Code is like "Opt1", "Opt2", ...
  const getPresetOptionValue = (side, option) => {
    const preset = side === "right" ? selectedPresetRight : selectedPresetLeft;

    if (!preset || !Array.isArray(preset.PresetValues)) return null;

    const opts = splitOptions(option.Options);

    // Try match by OptionCode first (e.g. "Opt1"), then by ValueType or Name
    const pv =
      preset.PresetValues.find((v) => v.OptionCode === option.Code) ||
      preset.PresetValues.find((v) => v.ValueType === option.Code) ||
      preset.PresetValues.find((v) => v.OptionCode === option.Name);

    if (!pv) return null;

    // Decide what string to use as the actual select value
    if (pv.OptionValue && opts.includes(pv.OptionValue)) return pv.OptionValue;
    if (pv.OptionCode && opts.includes(pv.OptionCode)) return pv.OptionCode;

    // If nothing matches exactly, last resort – still return something
    return pv.OptionValue || pv.OptionCode || null;
  };

  useEffect(() => {
    if (rightSelected && Array.isArray(customOptionsGroupRight)) {
      const updated = buildDefaults(customOptionsGroupRight, "right");
      setSelectedCustomOptionsRight(updated);

      if (linked && iteModelLinked && Array.isArray(customOptionsGroupLeft)) {
        // keep sides mapped by option name when linked
        const mappedLeft = customOptionsGroupLeft.map((leftOpt) => {
          const idx = customOptionsGroupRight.findIndex(
            (r) => r.Name === leftOpt.Name
          );
          return idx !== -1 ? updated[idx] : "";
        });
        setSelectedCustomOptionsLeft(mappedLeft);
      }
    }
  }, [
    customOptionsGroupRight,
    shellStyleRight,
    cartData,
    rightSelected,
    linked,
    iteModelLinked,
    selectedPresetRight,
  ]);

  useEffect(() => {
    if (leftSelected && Array.isArray(customOptionsGroupLeft)) {
      const updated = buildDefaults(customOptionsGroupLeft, "left");
      setSelectedCustomOptionsLeft(updated);

      if (linked && iteModelLinked && Array.isArray(customOptionsGroupRight)) {
        const mappedRight = customOptionsGroupRight.map((rightOpt) => {
          const idx = customOptionsGroupLeft.findIndex(
            (l) => l.Name === rightOpt.Name
          );
          return idx !== -1 ? updated[idx] : "";
        });
        setSelectedCustomOptionsRight(mappedRight);
      }
    }
  }, [
    customOptionsGroupLeft,
    shellStyleLeft,
    cartData,
    leftSelected,
    linked,
    iteModelLinked,
    selectedPresetLeft,
  ]);

  // ----------------------------
  // NEW: helpers for reconciliation
  // ----------------------------
  const splitOptions = (options) => (options || "").split("|");

  function allowedOptionsFor(option, side, currentSelections) {
    const presetVal = getPresetOptionValue(side, option);
    if (presetVal) return [presetVal];

    let opts = splitOptions(option.Options);

    if (manualVent) {
      // opts = opts.filter((o) => o !== manualVentOptionToRemove);
      opts = opts.filter(
        (o) =>
          !o?.toLowerCase().includes(manualVentOptionToRemove.toLowerCase())
      );
    }

    const shellStyle = side === "right" ? shellStyleRight : shellStyleLeft;
    if (
      shellStyle === "Canal_Mold" ||
      shellStyle === "Canal_Lock" ||
      shellStyle === "Carved_Half" ||
      shellStyle === "CanalMold" ||
      shellStyle === "CanalLock" ||
      shellStyle === "CarvedHalf"
    ) {
      opts = opts.filter((o) => o !== "Full Helix");
    }

    const selectedTube = currentSelections?.[1];
    if (selectedTube === "# 13 Dry Wall Tube") {
      opts = opts.filter((o) => !["00", "0", "2", "3"].includes(o));
    }

    if (cartData?.some((i) => i.ModelTypeCode?.includes("UP"))) {
      opts = opts.filter((o) => o !== "SlimTube 4.0");
    }

    return opts;
  }

  function chooseBest(option, allowed, prev) {
    if (prev && allowed.includes(prev)) return prev;
    if (option.DefaultValue && allowed.includes(option.DefaultValue))
      return option.DefaultValue;
    return allowed[0] ?? "";
  }

  // two-pass to account for dependencies between rows (tube → sizes etc.)
  function reconcileSide(side, group, prevSelections) {
    if (!Array.isArray(group)) return [];
    let next = group.map((opt, idx) =>
      chooseBest(
        opt,
        allowedOptionsFor(opt, side, prevSelections),
        prevSelections?.[idx]
      )
    );
    next = group.map((opt, idx) =>
      chooseBest(opt, allowedOptionsFor(opt, side, next), next[idx])
    );
    return next;
  }

  const arraysEqual = (a, b) =>
    Array.isArray(a) &&
    Array.isArray(b) &&
    a.length === b.length &&
    a.every((v, i) => v === b[i]);

  // ----------------------------
  // NEW: manualVent-only reconcile (prevents reset but cleans invalid values)
  // ----------------------------
  useEffect(() => {
    // RIGHT
    if (
      rightSelected &&
      Array.isArray(customOptionsGroupRight) &&
      selectedCustomOptionsRight.length
    ) {
      const reconciled = reconcileSide(
        "right",
        customOptionsGroupRight,
        selectedCustomOptionsRight
      );
      if (!arraysEqual(reconciled, selectedCustomOptionsRight)) {
        setSelectedCustomOptionsRight(reconciled);

        if (linked && iteModelLinked && Array.isArray(customOptionsGroupLeft)) {
          const mappedLeft = customOptionsGroupLeft.map((l) => {
            const idx = customOptionsGroupRight.findIndex(
              (r) => r.Name === l.Name
            );
            return idx !== -1 ? reconciled[idx] : "";
          });
          setSelectedCustomOptionsLeft(mappedLeft);
        }
      }
    }

    // LEFT
    if (
      leftSelected &&
      Array.isArray(customOptionsGroupLeft) &&
      selectedCustomOptionsLeft.length
    ) {
      const reconciled = reconcileSide(
        "left",
        customOptionsGroupLeft,
        selectedCustomOptionsLeft
      );
      if (!arraysEqual(reconciled, selectedCustomOptionsLeft)) {
        setSelectedCustomOptionsLeft(reconciled);

        if (
          linked &&
          iteModelLinked &&
          Array.isArray(customOptionsGroupRight)
        ) {
          const mappedRight = customOptionsGroupRight.map((r) => {
            const idx = customOptionsGroupLeft.findIndex(
              (l) => l.Name === r.Name
            );
            return idx !== -1 ? reconciled[idx] : "";
          });
          setSelectedCustomOptionsRight(mappedRight);
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [manualVent]); // ← only runs when manualVent toggles

  // ----------------------------
  // UPDATED: change handlers now reconcile to handle dependent rows
  // ----------------------------
  const handleCustomOptionsChangeRight = (event, index) => {
    const option = customOptionsGroupRight?.[index];

    // If we're using a preset AND this option has a preset value, do not allow manual change
    if (rightLocked && option && getPresetOptionValue("right", option)) {
      return;
    }

    const selectedValue = event.target.value;
    const next = [...selectedCustomOptionsRight];
    next[index] = selectedValue;

    const reconciled = reconcileSide("right", customOptionsGroupRight, next);
    setSelectedCustomOptionsRight(reconciled);

    if (linked && iteModelLinked) {
      const mappedLeft = customOptionsGroupLeft.map((leftOption, i) => {
        const matchIndex = customOptionsGroupRight.findIndex(
          (rightOption) => rightOption.Name === leftOption.Name
        );
        return matchIndex !== -1
          ? reconciled[matchIndex]
          : selectedCustomOptionsLeft[i] || "";
      });
      setSelectedCustomOptionsLeft(mappedLeft);
    }
  };

  const handleCustomOptionsChangeLeft = (event, index) => {
    const option = customOptionsGroupLeft?.[index];

    // If we're using a preset AND this option has a preset value, do not allow manual change
    if (leftLocked && option && getPresetOptionValue("left", option)) {
      return;
    }

    const selectedValue = event.target.value;
    const next = [...selectedCustomOptionsLeft];
    next[index] = selectedValue;

    const reconciled = reconcileSide("left", customOptionsGroupLeft, next);
    setSelectedCustomOptionsLeft(reconciled);

    if (linked && iteModelLinked) {
      const mappedRight = customOptionsGroupRight.map((rightOption, i) => {
        const matchIndex = customOptionsGroupLeft.findIndex(
          (leftOption) => leftOption.Name === rightOption.Name
        );
        return matchIndex !== -1
          ? reconciled[matchIndex]
          : selectedCustomOptionsRight[i] || "";
      });
      setSelectedCustomOptionsRight(mappedRight);
    }
  };

  return (
    <div>
      {(customOptionsGroupLeft || customOptionsGroupRight) &&
        (size(customOptionsGroupLeft) > 0 ||
          size(customOptionsGroupRight) > 0) &&
        (rightSelected || leftSelected) && (
          <div className="ite-custom-options-component-main-div order-builder-component">
            <Row className="order-builder-component-title">
              <Col xs={4}>
                <Row>
                  <Col md={12}>
                    <h2>Choose options</h2>
                  </Col>
                  <Col md={12}>
                    {(rightSelected || leftSelected) && hasAdvancedSettings && (
                      <div className="">
                        <h4>Advanced Mode</h4>
                        <label className="switch2">
                          <input
                            type="checkbox"
                            value={advancedMode}
                            onChange={() => setAdvancedMode(!advancedMode)}
                          />
                          <span className="slider2"></span>
                        </label>
                      </div>
                    )}
                  </Col>
                </Row>
              </Col>
              <Col xs={8}>
                <Row>
                  <Col md={5}>
                    {rightSelected && (
                      <div className="text-right">
                        <h3>Right Ear</h3>
                      </div>
                    )}
                  </Col>
                  <Col md={2}>
                    {rightSelected && leftSelected && (
                      <div className="text-center link-div">
                        {linked && iteModelLinked ? (
                          <InsertLink
                            className="linked"
                            onClick={() => setLinked(false)}
                          />
                        ) : (
                          <LinkOff
                            onClick={() => setLinked(!linked)}
                            className="unlinked"
                          />
                        )}
                      </div>
                    )}
                  </Col>
                  <Col md={5}>
                    {leftSelected && (
                      <div>
                        <h3>Left Ear</h3>
                      </div>
                    )}
                  </Col>
                  <Col md={6}>
                    {rightSelected &&
                      Array.isArray(customOptionsGroupRight) && (
                        <Row className="ite-custom-options-row-right">
                          {customOptionsGroupRight.map((options, index) => {
                            const presetVal = getPresetOptionValue(
                              "right",
                              options
                            );

                            var optionsAfterSplit = splitOptions(
                              options.Options
                            );
                            if (manualVent) {
                              remove(optionsAfterSplit, function (o) {
                                // return o == manualVentOptionToRemove;
                                return o
                                  ?.toLowerCase()
                                  .includes(
                                    manualVentOptionToRemove.toLowerCase()
                                  );
                              });
                            }
                            if (
                              shellStyleRight == "Canal_Mold" ||
                              shellStyleRight == "Canal_Lock" ||
                              shellStyleRight == "Carved_Half" ||
                              shellStyleRight === "CanalMold" ||
                              shellStyleRight === "CanalLock" ||
                              shellStyleRight === "CarvedHalf"
                            ) {
                              remove(optionsAfterSplit, function (o) {
                                return o == "Full Helix";
                              });
                            }
                            if (
                              selectedCustomOptionsRight[1] ==
                              "# 13 Dry Wall Tube"
                            ) {
                              remove(optionsAfterSplit, function (o) {
                                return (
                                  o == "00" || o == "0" || o == "2" || o == "3"
                                );
                              });
                            }
                            if (cartData) {
                              let isUP = cartData.some(
                                (item) =>
                                  item.ModelTypeCode &&
                                  item.ModelTypeCode.includes("UP")
                              );
                              if (isUP) {
                                remove(optionsAfterSplit, function (o) {
                                  return o == "SlimTube 4.0";
                                });
                              }
                            }

                            if (
                              presetVal &&
                              !optionsAfterSplit.includes(presetVal)
                            ) {
                              optionsAfterSplit = [
                                presetVal,
                                ...optionsAfterSplit,
                              ];
                            }

                            return (
                              <Col
                                key={index}
                                xs={12}
                                className="ite-custom-options-div"
                              >
                                <Row>
                                  <Col md={6}>
                                    <div className="select">
                                      {(!options.IsAdvanced ||
                                        advancedMode) && (
                                        <select
                                          name={`${options.Name}Right`}
                                          value={
                                            selectedCustomOptionsRight[index] ||
                                            ""
                                          }
                                          onChange={(e) =>
                                            handleCustomOptionsChangeRight(
                                              e,
                                              index
                                            )
                                          }
                                          disabled={rightLocked && !!presetVal}
                                        >
                                          {optionsAfterSplit &&
                                            optionsAfterSplit.map(
                                              (option, i) => (
                                                <option key={i} value={option}>
                                                  {option}
                                                </option>
                                              )
                                            )}
                                        </select>
                                      )}
                                      {options.IsAdvanced && !advancedMode && (
                                        <p
                                          key={
                                            selectedCustomOptionsRight[index]
                                          }
                                        >
                                          {selectedCustomOptionsRight[index] ||
                                            "-"}
                                        </p>
                                      )}
                                    </div>
                                  </Col>
                                  <Col md={6}>
                                    <p>{options.Name}</p>
                                  </Col>
                                </Row>
                              </Col>
                            );
                          })}
                        </Row>
                      )}
                  </Col>
                  <Col md={6} className="left-side">
                    {leftSelected && Array.isArray(customOptionsGroupLeft) && (
                      <Row className="ite-custom-options-row-left">
                        {customOptionsGroupLeft.map((options, index) => {
                          const presetVal = getPresetOptionValue(
                            "left",
                            options
                          );

                          var optionsAfterSplit = splitOptions(options.Options);
                          if (manualVent) {
                            remove(optionsAfterSplit, function (o) {
                              // return o == manualVentOptionToRemove;
                              return o
                                ?.toLowerCase()
                                .includes(
                                  manualVentOptionToRemove.toLowerCase()
                                );
                            });
                          }
                          if (
                            shellStyleLeft == "Canal_Mold" ||
                            shellStyleLeft == "Canal_Lock" ||
                            shellStyleLeft == "Carved_Half" ||
                            shellStyleLeft === "CanalMold" ||
                            shellStyleLeft === "CanalLock" ||
                            shellStyleLeft === "CarvedHalf"
                          ) {
                            remove(optionsAfterSplit, function (o) {
                              return o == "Full Helix";
                            });
                          }
                          if (
                            selectedCustomOptionsLeft[1] == "# 13 Dry Wall Tube"
                          ) {
                            remove(optionsAfterSplit, function (o) {
                              return (
                                o == "00" || o == "0" || o == "2" || o == "3"
                              );
                            });
                          }
                          if (cartData) {
                            let isUP = cartData.some(
                              (item) =>
                                item.ModelTypeCode &&
                                item.ModelTypeCode.includes("UP")
                            );
                            if (isUP) {
                              remove(optionsAfterSplit, function (o) {
                                return o == "SlimTube 4.0";
                              });
                            }
                          }

                          if (
                            presetVal &&
                            !optionsAfterSplit.includes(presetVal)
                          ) {
                            optionsAfterSplit = [
                              presetVal,
                              ...optionsAfterSplit,
                            ];
                          }
                          return (
                            <Col
                              key={index}
                              xs={12}
                              className="ite-custom-options-div"
                            >
                              <Row>
                                <Col md={6}>
                                  <div className="select">
                                    {(!options.IsAdvanced || advancedMode) && (
                                      <select
                                        name={`${options.Name}Left`}
                                        value={
                                          selectedCustomOptionsLeft[index] || ""
                                        }
                                        onChange={(e) =>
                                          handleCustomOptionsChangeLeft(
                                            e,
                                            index
                                          )
                                        }
                                        disabled={leftLocked && !!presetVal}
                                      >
                                        {optionsAfterSplit &&
                                          optionsAfterSplit.map((option, i) => (
                                            <option key={i} value={option}>
                                              {option}
                                            </option>
                                          ))}
                                      </select>
                                    )}
                                    {options.IsAdvanced && !advancedMode && (
                                      <p key={selectedCustomOptionsLeft[index]}>
                                        {selectedCustomOptionsLeft[index] ||
                                          "-"}
                                      </p>
                                    )}
                                  </div>
                                </Col>
                                <Col md={6}>
                                  <p className="">{options.Name}</p>
                                </Col>
                              </Row>
                            </Col>
                          );
                        })}
                      </Row>
                    )}
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
        )}
    </div>
  );
};

export default ITECustomOptions;
